<template>
  <div>
    <div id="map"></div>

    <div class="menu">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-form-model-item>
            <InputField labelWidth="0" type="text" id="name" v-model="form.name" placeholder="排污企业名称"/>
        </a-form-model-item>
        <a-form-model-item>
            <SelectField labelWidth="0" :options="waterqualityList" v-model="form.deviceId" id="deviceId" placeholder="水质监测箱"/>
        </a-form-model-item>

        <a-form-model-item>
          <a-space>
              <ButtonField text="查询" @click="query" secondary />
              <ButtonField text="重置" primary @click="reset"/>
              <ButtonField text="新增" @click="add" secondary />
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>

    <Detail
      v-if="visible"
      :status="status"
      :waterqualityList="waterqualityList"
      :selectedLnglat="selectedLnglat"
      :selectedWaterQuality="selectedWaterQuality"
      :detail="detail"
      @cancel="cancel"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import Detail from "./components/detail.vue";

import request from "@/api/request";

import waterQualityMarkerImage from "@/assets/assets/bottom-bar/water-monitor-active.png";

export default {
  components: {
    Detail,
  },

  data() {
    return {
      form: {},
      list: [],
      waterqualityList: [],

      visible: false,
      status: "",
      selectedWaterQuality: {},
      selectedLnglat: {},

      detail: {},
    };
  },

  mounted() {
    this.initMap();

    this.getList();
    this.getWaterQuality();
  },

  beforeDestroy() {
    this.markers?.forEach((item) => {
      item.off("click", this.onMarkerClick);
    });

    this.waterqualityMarkers?.forEach((item) => {
      item.off("click", this.onWaterQualityMarkerClick);
    });

    this.map?.off("click", this.onMarkerClick);

    this.map?.clearMap();
    this.map?.destroy();
  },

  methods: {
    initMap() {
      const { AMap } = window;
      if (!AMap) {
        return;
      }
      var map = new AMap.Map("map", {
        center: [118.536766,32.993047],
        zoom: 16,
        mapStyle: "amap://styles/light",
        // mapStyle: "amap://styles/f3c7464cbaf52050e35d00dc506f4069",
      });

      this.map = map;

      this.map.on("click", this.onMapClick);
    },

    onMapClick(e) {
      this.selectedLnglat = {
        lng: e.lnglat.getLng(),
        lat: e.lnglat.getLat(),
      };
    },

    getList() {
      const hide = this.$message.loading("加载中...");
      request({
        url: "/model-analysis/pipe/sewageDischarger/listPage",
        method: "post",
        data: {
          pageNum: 1,
          pageSize: 399,
          ...this.form,
        },
      })
        .then((res) => {
          if (res && Array.isArray(res.list) && res.list.length > 0) {
            this.list = Object.freeze(res.list);
            this.addMarker();
          } else {
            this.list = [];
            this.addMarker();
          }
        })
        .finally(() => {
          hide();
        });
    },

    getWaterQuality() {
      request({
        url: "/model-analysis/pipe/facility/all",
      }).then((res) => {
        if (Array.isArray(res)) {
          this.waterqualityList = Object.freeze(
            res.filter((item) => item.type === "waterquality")
          );
          this.addWaterQualityMarker();
        }
      });
    },

    query() {
      this.getList();
    },

    reset() {
      this.form = {};
      this.getList();
      this.getWaterQuality();
    },

    addMarker() {
      if (Array.isArray(this.markers)) {
        this.markers.forEach((item) => {
          item.off("click", this.onMarkerClick);
          this.map?.remove(item);
        });
      }

      const markers = this.list.map((item) => {
        const content = `<div>
                <div style='background-color:#1890ff;color: #fff;border-radius: 4px;padding: 4px 8px;text-align:center;min-width: 240px'>${item.name}</div>
              </div>
            `;

        const marker = new window.AMap.Marker({
          position: [item.x, item.y],
          content,
          extData: item,
        });

        marker.on("click", this.onMarkerClick);
        return marker;
      });

      this.map.add(markers);
      this.markers = markers;
    },

    addWaterQualityMarker() {
      if (Array.isArray(this.waterqualityMarkers)) {
        this.waterqualityMarkers.forEach((item) => {
          item.off("click", this.onWaterQualityMarkerClick);
          this.map?.remove(item);
        });
      }

      const markers = this.waterqualityList.map((item) => {
        const icon = new window.AMap.Icon({
          image: waterQualityMarkerImage,
          imageSize: [24, 24],
        });

        const marker = new window.AMap.Marker({
          position: [item.x, item.y],
          icon,
          extData: item,
        });

        marker.on("click", this.onWaterQualityMarkerClick);
        return marker;
      });

      this.map.add(markers);
      this.waterqualityMarkers = markers;
    },

    onMarkerClick(e) {
      console.log(e);
      this.cancel();
      this.detail = e.target._opts.extData;
      this.status = "edit";
      this.visible = true;
    },

    onWaterQualityMarkerClick(e) {
      console.log(e);
      this.selectedWaterQuality = e.target._opts.extData;
    },

    add() {
      this.visible = true;
      this.status = "add";
    },
    cancel() {
      this.visible = false;
      this.status = "";
      (this.selectedLnglat = {}), (this.selectedWaterQuality = {});
      this.detail = {};
    },
    refresh() {
      this.getList();
    },
  },
};
</script>
  
  
<style lang="less" scoped>
#map {
  position: fixed;
  height: 105vh;
  width: 100vw;
  left: 0;
  top: 0;
}

.menu {
  position: fixed;
  top: 11vh;
  left: 1vw;
  background-color: var(--default-bgcolor);
  border-radius: 8px;
  padding: 1vh;
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 255, 150, 0.3);
}
</style>